<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-6">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Teeltsoort</strong>
                        <small>
                            <span v-if="isEditing">wijzigen</span>
                            <span v-else>toevoegen</span>
                        </small>
                    </div>
                    <form @submit.prevent="saveItem">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label" for="naam">Naam <sup>*</sup></label>
                                <input type="text" v-model="model.naam" id="naam" name="naam" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('naam') }" />
                                <span class="small text-danger" v-show="errors.has('naam')">Naam is verplicht</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="col-form-label" for="ingesteldeDli">Ingestelde DLI <sup>*</sup></label>
                                <input type="number" step=".1" min="0" max="99.9" v-model="model.ingesteldeDli" id="ingesteldeDli" name="ingesteldeDli" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('ingesteldeDli') }" />
                                <span class="small text-danger" v-show="errors.has('ingesteldeDli')">Ingestelde DLI is verplicht</span>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="col-form-label" for="lengteLichtperiode">Lengte lichtperiode <sup>*</sup></label>
                                <input type="number" step=".1" min="0" max="99.9" v-model="model.lengteLichtperiode" id="lengteLichtperiode" name="lengteLichtperiode" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('lengteLichtperiode') }" />
                                <span class="small text-danger" v-show="errors.has('lengteLichtperiode')">Lengte lichtperiode is verplicht</span>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="col-form-label" for="aantalDagenTotVolgroeid">Aantal dagen tot volgroeid <sup>*</sup></label>
                                <input type="number" step="1" min="0" max="999" v-model="model.aantalDagenTotVolgroeid" id="aantalDagenTotVolgroeid" name="aantalDagenTotVolgroeid" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('aantalDagenTotVolgroeid') }" />
                                <span class="small text-danger" v-show="errors.has('aantalDagenTotVolgroeid')">Aantal dagen is verplicht</span>
                            </div>
                        </div>
                    </div>
                    <div slot="footer">
                        <b-button type="submit" variant="primary">
                            <span>Opslaan</span>
                        </b-button>
                        <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                    </div>
                    </form>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Form',
        props: ['model', 'isEditing'],
        methods: {
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('save-item', this.model);
                    }
                });
            },
            back () {
                this.$router.go(-1);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/teelt/Form.vue